import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AdminStatePipe} from './admin-state/admin-state.pipe';
import {CacStatePipe} from './cac-state/cac-state.pipe';
import {OperativeStatePipe} from './operative-state/operative-state.pipe';
import {TrueFalsePipe} from './true-false/true-false.pipe';
import { DateTimePipe } from './date-time/date-time.pipe';
import {DateTimeSecPipe} from './date-time/date-time-sec.pipe';
import {ListDisplayPipe} from './list-display/list-display.pipe';
import {RouterAddressPipe} from './router-address/router-address.pipe';

@NgModule({
  declarations: [
    AdminStatePipe,
    CacStatePipe,
    OperativeStatePipe,
    TrueFalsePipe,
    DateTimePipe,
    DateTimeSecPipe,
    ListDisplayPipe,
    RouterAddressPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AdminStatePipe,
    CacStatePipe,
    OperativeStatePipe,
    TrueFalsePipe,
    RouterAddressPipe
  ]
})
export class PipsModule { }
